import React from "react"
import { useToast } from "~/utils/Toast"
import getAppConfig from "~/utils/getAppConfig"
import { capitalize } from "~/utils/helpers"

import { apiSponsorshipAreas } from "~/routes"
import CatchModal from "~/library/CatchModal"
import AreaForm from "~/components/Sponsorship/AreaForm"
import { AreaType } from "~/types/sponsorship/Area"

interface NewAreaProps {
  isOpen: boolean
  onClose: () => void
  onSuccess: (areaType: AreaType) => void
  areaType: AreaType
}

const NewArea: React.FC<NewAreaProps> = ({ isOpen, onClose, onSuccess, areaType }) => {
  const { venueSlug } = getAppConfig()
  const toast = useToast()

  const handleSubmit = (formValues: any) => {
    const data = {
      venue_slug: venueSlug,
      sponsorshipArea: {
        ...formValues,
        areaType,
      },
    }

    const req = apiSponsorshipAreas.create({ data })

    req
      .then((res) => {
        toast("Sponsorship area created successfully", "success")
        onSuccess(res.sponsorshipArea.areaType)
        onClose()
      })
      .catch((res) => {
        toast(
          `Error creating sponsorship area. ${res.body?.errors?.join(", ") || "Please try again"}`,
          "danger"
        )
      })
  }

  return (
    <CatchModal
      isOpen={isOpen}
      onClose={onClose}
      title={`New ${capitalize(areaType)} Sponsorship Area`}
    >
      <AreaForm
        onSubmit={handleSubmit}
        onCancel={onClose}
        areaType={areaType}
        hideAreaType={true}
      />
    </CatchModal>
  )
}

export default NewArea
